// src/services/subscriptionService.js
import axiosInstance from "../axios";

const PAYMENT_BANK_ACCOUNTS_ENDPOINT = "/payment-bank-accounts";
const MANUAL_UPGRADE_ENDPOINT = "/subscription-upgrades/manual";

export const fetchPaymentBankAccounts = async () => {
  const response = await axiosInstance.get(PAYMENT_BANK_ACCOUNTS_ENDPOINT);
  return response?.data?.data || [];
};

export const createManualSubscriptionUpgrade = async (payload) => {
  const response = await axiosInstance.post(MANUAL_UPGRADE_ENDPOINT, payload);
  return response?.data?.data || null;
};

export const uploadTransferProof = async (paymentId, formData) => {
  const response = await axiosInstance.post(
    `/subscription-payments/${paymentId}/proof`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response?.data?.data || null;
};
